"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledLink = void 0;
var _mui = require("@ori-ui/mui");
const StyledLink = exports.StyledLink = (0, _mui.styled)(_mui.Link)(({
  theme
}) => ({
  display: 'inline-block',
  textDecoration: 'underline'
}));
